export const pageConfig = {
  "model_title": "GPT 4o",
  "price_per_million_token": 5,
  "max_token": 128_000
}

export type PageConfig = typeof pageConfig
